import React, { useEffect, useState, useRef } from "react";
import Modal from "react-modal";
import {
  Button,
  Grid,
  GridColumn,
  GridRow,
  Icon,
  Image,
} from "semantic-ui-react";
import { useRouter } from "next/router";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    maxWidth: "420px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};

const ShareModal = (props) => {
  const linkInputRef = useRef(null);
  const [currentUrl, setCurrentUrl] = useState("");
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);
  const shareIcon = [
    {
      name: "facebook",
      link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        currentUrl
      )}`,
      imageUrl: `${process.env.NEXT_PUBLIC_CDN_ID}static/images/share_icons/facebook.png`,
    },
    {
      name: "twitter",
      imageUrl: `${process.env.NEXT_PUBLIC_CDN_ID}static/images/share_icons/twitter.png`,
      link: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        currentUrl
      )}`,
    },
    {
      name: "instagram",
      imageUrl: `${process.env.NEXT_PUBLIC_CDN_ID}static/images/share_icons/instagram.png`,
      link: "https://www.instagram.com",
    },
    {
      name: "mail",
      imageUrl: `${process.env.NEXT_PUBLIC_CDN_ID}static/images/share_icons/mail.png`,
      link: `mailto:?subject=${encodeURIComponent(
        "Check this out!"
      )}&body=${encodeURIComponent("I found this interesting: " + currentUrl)}`,
    },
    {
      name: "linkedin",
      imageUrl: `${process.env.NEXT_PUBLIC_CDN_ID}static/images/share_icons/linkedin.png`,
      link: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        currentUrl
      )}`,
    },
  ];
  const handleIconClick = (link) => {
    window.open(link, "_blank");
  };
  const handleCopyLink = () => {
    if (linkInputRef.current) {
      linkInputRef.current.select();
      document.execCommand("copy");
      alert("Link copied to clipboard!");
    }
  };

  const handleRequestCloseShareModel = () => {
    setClosing(true);
    setTimeout(() => {
      props.handleCloseShareModal();
      setClosing(false);
    }, 300);
  };
  return (
    <div>
      <Modal
        isOpen={props.isShareModalOpen}
        onRequestClose={handleRequestCloseShareModel}
        style={{
          content: {
            ...customStyles.content,
            animation: closing
              ? "shareSlideOut 0.5s ease-out"
              : "shareSlideIn 0.7s ease-out",
          },
          overlay: customStyles.overlay,
        }}
        contentLabel="Example Modal"
      >
        <div
          className="share_close_icon"
          onClick={handleRequestCloseShareModel}
        >
          <a className="boxclose" id="boxclose"></a>
        </div>
        <Grid className="modal_grid">
          <GridRow>
            <GridColumn mobile={16} tablet={16} computer={16}>
              <div className="share_modal">
                <p className="modal_share_title">Share this page</p>
              </div>
              <div className="ui divider divider_modal_grid"></div>
              <p className="modal_share_sub_title">Share this link via</p>
              <div className="share_icon_container">
                {shareIcon.map((item) => (
                  <div
                    key={item.name}
                    className={`share_icon`}
                    onClick={() => handleIconClick(item.link)}
                  >
                    {/* <Icon
                      size="big"
                      name={item.name}
                      style={{
                        color: item.color,
                      }}
                    /> */}
                    <Image
                      style={{ height: "35px", width: "35px" }}
                      src={item.imageUrl}
                      title={item.name}
                      alt={item.name}
                    />
                  </div>
                ))}
              </div>
              <div className="ui divider divider_modal_grid"></div>
              <div className="copy-link-container">
                <input
                  ref={linkInputRef}
                  type="text"
                  value={currentUrl}
                  readOnly
                  className="copy-link-input"
                />
                <Button
                  onClick={handleCopyLink}
                  primary
                  size="mini"
                  className="copy-link-button"
                >
                  Copy
                </Button>
              </div>
            </GridColumn>
          </GridRow>
        </Grid>
      </Modal>
    </div>
  );
};

export default ShareModal;
